import { FC } from 'react';
import { useSelector } from 'react-redux';

import { H3, Spinner } from '@portal/common/components';
import { styled } from '@portal/common/theme';

import _ from '../../../locale';
import { GROUP_CONTENT_ID } from '../../../router/paths';
import { getGroupContentResources, getPublicLists } from '../../../store/resource-lists/selectors';
import ListItem from './ListItem';
import ListsMenu from './ListsMenu';

const StyledSpinner = styled(Spinner)({
    marginLeft: 10,
});

const Header = styled('div')(({ theme }) => ({
    color: theme.color.white,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    padding: '40px 0 16px',
}));

const List = styled('div')({
    display: 'flex',
    flexFlow: 'column nowrap',
    '> *': {
        flexShrink: 0,
    },
});

const groupList = {
    name: _('default_group_list_name'),
    id: GROUP_CONTENT_ID,
};

const PublicListsMenu: FC = () => {
    const publicLists = useSelector(getPublicLists);
    const groupContentResources = useSelector(getGroupContentResources);

    const groupContentCount = groupContentResources?.length;

    return (
        <>
            <Header>
                <H3>{_.get('lists_public_lists_header')}</H3>
                {publicLists == null && <StyledSpinner />}
            </Header>
            <List>
                <ListItem list={groupList} resourceCount={groupContentCount} />
                {publicLists != null && <ListsMenu items={publicLists} isPublic />}
            </List>
        </>
    );
};

export default PublicListsMenu;
